import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Address } from '@/types/shipment.types';

interface ShipmentMapProps {
  address: Address;
}

export function ShipmentMap({ address }: ShipmentMapProps) {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const map = L.map(mapRef.current).setView([address.lat, address.lng], 14);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
    }).addTo(map);

    const marker = L.marker([address.lat, address.lng]).addTo(map);
    marker.bindPopup(`
      <div style="direction: rtl; text-align: right;">
        <strong>${address.city}</strong><br/>
        ${address.neighborhood}<br/>
        ${address.street}
      </div>
    `);

    mapInstanceRef.current = map;

    return () => {
      map.remove();
      mapInstanceRef.current = null;
    };
  }, [address]);

  return <div ref={mapRef} className="h-full w-full rounded-lg" />;
}
